import React, { useEffect, useState } from "react";
import Navbar from "./Navbar.jsx";
import Footer from "./Footer.jsx";
// import AboutUs from "./AboutUs.jsx";
import About from "./About.jsx";
import Portfolio from "./Portfolio.jsx";
import GuidePage from "./GuidePage.jsx";
import News from "./News.jsx";
// useState
const TwoDUI_for_scene2 = (props) => {
  const [aboutPhilosophy, setAboutPhilosophy] = useState(false);
  const [aboutInfo, setAboutInfo] = useState(false);
  const [aboutPartners, setAboutPartners] = useState(false);
  const [news, setNews] = useState(false);
  const [pf, setPF] = useState(false);
  const [guide, setGuide] = useState(false);


  const [full, setFull] = useState(false);

  // useEffect(() => {
    function fullScreen(){

      setFull((e)=>!e);
    }
  // }, [props.fullScreen]);

 


  return (
    <div style={{zIndex:"100000000000"}}>
      
      {!full && !aboutPhilosophy && !aboutInfo && !aboutPartners && !pf && !news && !guide && (
        <Navbar
          goToNewsPoster={() => {
            props.goToNewsPoster();
          }}
          goToAboutPhilosophy={() => {
            setAboutPhilosophy(true);
          }}
          goToAboutInfo={() => {
            setAboutInfo(true);
          }}
          goToAboutPartners={() => {
            setAboutPartners(true);
          }}
          goToPF={() => {
            setPF(true);
          }}
          goToNews={() => {
            setNews(true);
          }}
          goToGuide={() => {
setGuide(true);
          }}
        />
      )}

      {(aboutPhilosophy || aboutInfo || aboutPartners) && !guide && !pf && !news && (
        <About
        goToAboutPhilosophy={aboutPhilosophy}
        goToAboutInfo={aboutInfo}
        goToAboutPartners={aboutPartners}
          cancelAbout={() => {
            setAboutPhilosophy(false);
            setAboutInfo(false);
            setAboutPartners(false);
          }}
        />
      )}

      {/* {!aboutPhilosophy && aboutInfo && !aboutPartners &&  !guide && !pf && !news && (
        <AboutInfo
          cancelAbout={() => {
            setAboutInfo(false);
          }}
        />
      )}

      {!aboutPhilosophy && !aboutInfo && aboutPartners  && !guide &&  !pf && !news && (
        <AboutPartners
          cancelAbout={() => {
            setAboutPartners(false);
          }}
        />
      )} */}

      {!aboutPhilosophy && !aboutInfo && !aboutPartners  && !guide &&  pf && !news && (
        <Portfolio
          cancelPF={() => {
            setPF(false);
            // gsap.to(cameraRef.current.position, {
            //   duration: 2,
            //   x: 0,
            //   y: 250,
            //   z: 710,
              // ease: "power1.inOut",
            // });
          }}
        />
      )}

      {!aboutPhilosophy && !aboutInfo && !aboutPartners  && !guide &&  !pf && news && (
        <News
          cancelNews={() => {
            setNews(false);
          }}
        />
      )}
      {!aboutPhilosophy && !aboutInfo && !aboutPartners  && guide &&  !pf && !news && (
        <GuidePage
        cancelGuide={() => {
            setGuide(false);
          }}
        />
      )}

      {!aboutPhilosophy && !aboutInfo && !aboutPartners  && !guide &&  !pf && !news && <Footer fullScreen={()=>{fullScreen()}}/>}
    </div>
  );
};

export default TwoDUI_for_scene2;
